// src/HelpPage.js
import React from 'react';
import "./HelpPage.css"
import CardHeader from '../header/cardHeader';

const HelpPage = () => {
  return (
    <>
      <CardHeader />
      <div className="help-page">
        <header>
          <h1>HRMS Help Center</h1>
          <p>Your go-to resource for HR-related inquiries</p>
        </header>

        <section id="benefits">
          <h2>Employee Benefits</h2>
          <p>We offer a variety of employee benefits, including health insurance, retirement plans, and wellness programs.</p>
        </section>

        <section id="leave-policy">
          <h2>Leave Policies</h2>
          <p>Our leave policies cover annual leave, sick leave, and other special leaves. You can apply for leaves through the HRMS portal.</p>
        </section>

        <section id="payroll">
          <h2>Payroll and Salary</h2>
          <p>Find out more about your payroll schedule, salary structure, and how to resolve payroll-related queries.</p>
        </section>

        <section id="attendance">
          <h2>Attendance and Time Tracking</h2>
          <p>Learn how to track your work hours, manage overtime, and request time off through our HRMS system.</p>
        </section>

        <footer>
          <p>For additional help, please contact the HR department or visit our FAQ section.</p>
        </footer>
      </div>
    </>
  );
};

export default HelpPage;
